(function () {
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-mt-delay') || 0;
            setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
          var dur = 1400;
          var inicio = null;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var prog = Math.min((ts - inicio) / dur, 1);
            var val = fin * (1 - Math.pow(1 - prog, 3));
            el.textContent = (Number.isInteger(fin) ? Math.round(val) : val.toFixed(1)).toString();
            if (prog < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
          observer.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
  });
})();
